import React, { useEffect, useState } from "react";
import Header from "../../common/header/Header";
import Footer from "../../common/footer/Footer";
import { updateTocart } from "../../../redux/slices/cartSlice";
import { useDispatch, useSelector } from "react-redux";
import { REACT_APP_URL, API_BASE_URL } from "../../../config/config";
import CartHeaderImage from "../../../Images/CartHeaderImage.png";
import axios from "axios";
import Spinner from "../../common/Spinner";
import { toastError, toastSuceess } from "../../../util/reactToastify";
import { resetCart } from "../../../redux/slices/cartSlice";

function Checkout() {
  const { cartdata } = useSelector((state) => state.cart);
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [cartItem, setCartItem] = useState([]);
  const [totalQnt, setTotalQnt] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [totalAmmount, setTotalAmmount] = useState(0);

  // Coupon state
  const [couponCode, setCouponCode] = useState("");
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [finalAmount, setFinalAmount] = useState(0);
  const [couponLoading, setCouponLoading] = useState(false);
  const [couponError, setCouponError] = useState("");
  const [couponSuccess, setCouponSuccess] = useState("");

  const [options, setOptions] = useState({
    atomTokenId: "",
    merchId: "",
    custEmail: "",
    custMobile: "",
    returnUrl: `${API_BASE_URL}/GateWay/Response`,
  });
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobileNo: "",
    address: "",
    city: "",
    state: "",
    country: "India",
    pincode: "",
  });
  function openPay() {
    window.AtomPaynetz(options, "uat");
  }
  useEffect(() => {
    if (
      options.atomTokenId !== "" &&
      options.merchId !== "" &&
      options.custEmail !== "" &&
      options.custMobile !== ""
    ) {
      openPay();
    }
  }, [options]);

  const cartdataitem = cartdata.map((cart) => ({
    bookId: cart.id,
    quantity: cart.quantity,
    price: cart.mRP,
  }));

  function handleChange(event) {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  }

  // Validate and apply coupon
  async function validateCoupon() {
    if (!couponCode.trim()) {
      setCouponError("Please enter a coupon code");
      return;
    }

    setCouponLoading(true);
    setCouponError("");
    setCouponSuccess("");

    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/coupon/validate`,
        {
          couponCode: couponCode.trim(),
          orderAmount: totalAmmount,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.isValid) {
        setAppliedCoupon(response.data.coupon);
        setDiscountAmount(response.data.discountAmount);
        setFinalAmount(response.data.finalAmount);
        setCouponSuccess(response.data.message);
        setCouponError("");
      } else {
        setCouponError(response.data.message);
        setAppliedCoupon(null);
        setDiscountAmount(0);
        setFinalAmount(totalAmmount);
      }
    } catch (error) {
      setCouponError(error?.response?.data?.message || "Failed to validate coupon");
      setAppliedCoupon(null);
      setDiscountAmount(0);
      setFinalAmount(totalAmmount);
    }

    setCouponLoading(false);
  }

  // Remove applied coupon
  function removeCoupon() {
    setCouponCode("");
    setAppliedCoupon(null);
    setDiscountAmount(0);
    setFinalAmount(totalAmmount);
    setCouponError("");
    setCouponSuccess("");
  }

  // Record coupon usage after successful payment
  async function recordCouponUsage(orderId) {
    if (appliedCoupon) {
      try {
        await axios.post(
          `${API_BASE_URL}/api/coupon/recordUsage`,
          {
            couponCodeId: appliedCoupon.id,
            orderId: orderId,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
      } catch (error) {
        console.error("Failed to record coupon usage:", error);
      }
    }
  }

  /**handle submit  */
  async function handleSubmit(event) {
    event.preventDefault();
    setLoader(true);
    try {
      const response1 = await axios.post(
        `${API_BASE_URL}/api/UserTokenApi`,
        { ...formData },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // console.log(response1.data)
      localStorage.setItem("token", response1.data.response);

      localStorage.setItem("userid", response1.data.userId);

      // Include coupon data in order
      const orderData = {
        ...formData,
        orderMetas: cartdataitem,
        couponCodeId: appliedCoupon?.id || "",
        discountAmount: discountAmount,
      };

      const response = await axios.post(
        `${API_BASE_URL}/api/OrderApi`,
        orderData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${response1.data.response}`,
          },
        }
      );
      //console.log("Token:", response.data.order.tokenId);
      if (
        response?.data?.order?.tokenId !== "" &&
        response?.data?.order?.merchId !== "" &&
        response?.data?.message === "Success"
      ) {
        // Store order ID for coupon usage recording after payment
        localStorage.setItem("pendingOrderId", response?.data?.order?.id);
        localStorage.setItem("pendingCouponId", appliedCoupon?.id || "");

        // toastSuceess("Your order has picked successfully");
        const newData = {
          atomTokenId: response?.data?.order?.tokenId,
          merchId: response?.data?.order?.merchId,
          custEmail: response?.data?.order?.email,
          custMobile: response?.data?.order?.mobileNo,
        };
        setOptions((prev) => ({ ...prev, ...newData }));

        // dispatch(resetCart());
      }
    } catch (error) {
      toastError(error?.response?.data?.message);
    }
    setLoader(false);
    // dispatch(resetCart());
  }
  useEffect(() => {
    setCartItem(cartdata);
    setTotalQnt(0);
    setTotalPrice(0);
    setTotalAmmount(0);
  }, [cartdata]);

  useEffect(() => {
    if (cartItem.length > 0) {
      let tempTotalQnt = 0;
      let tempTotalPrice = 0;
      let tempTotalAmmount = 0;
      cartItem?.map((book) => {
        tempTotalQnt += parseInt(book.quantity);
        tempTotalPrice += parseInt(book.mRP);
        tempTotalAmmount += parseInt(book.quantity) * parseInt(book.mRP);
      });
      setTotalQnt(tempTotalQnt);
      setTotalPrice(tempTotalPrice);
      setTotalAmmount(tempTotalAmmount);
      // Update final amount when cart changes
      if (!appliedCoupon) {
        setFinalAmount(tempTotalAmmount);
      }
    }
  }, [cartItem]);
  const updateOnChangeHandler = (newVal, currentObj) => {
    let updatedObj = { ...currentObj };
    updatedObj.quantity = newVal;

    const {
      id,
      authors,
      bookCode,
      courseSemesters,
      image,
      isFeatured,
      languageId,
      quantity,
      languageNav,
      mRP,
      numId,
      name,
      ...rest
    } = updatedObj;
    dispatch(
      updateTocart({
        product: {
          id,
          authors,
          bookCode,
          courseSemesters,
          image,
          isFeatured,
          languageId,
          languageNav,
          mRP,
          numId,
          name,
          quantity,
        },
      })
    );
  };

  return (
    <>
      {loader && <Spinner />}
      <Header />
      <div
        className="Headerrowabout"
        style={{
          backgroundImage: `url(${CartHeaderImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "70vh",
        }}
      >
        <div className="gradient-overlay gradientoverlaystyle" />
        <div className="col-lg-2" style={{ float: "left" }}>
          &nbsp;
        </div>
        <div className="col-lg-8" style={{ float: "left" }}>
          <div className="video-content aboutusheader">
            <p
              className="text"
              style={{
                textTransform: "uppercase",
                fontSize: 50,
                fontWeight: 600,
                textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
              }}
            >
              Check Out
            </p>
            <p style={{ fontSize: 20 }}>
              Asian Publishers is your life long Learning Partner. We have
              empowered the growth of Students,Teachers, &amp; Professionals
              since 1981.
            </p>
          </div>
        </div>
        <div className="col-lg-2" style={{ float: "left" }}>
          &nbsp;
        </div>
      </div>
      <br />
      <div
        className="row"
        id="AboutUsSection"
        style={{ display: "block", margin: 0, padding: 0, clear: "both" }}
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-6 col-md-6">
              <div
                className="contact-from contact-shadow"
                style={{ marginLeft: 0 }}
              >
                <form
                  method="post"
                  onSubmit={handleSubmit}
                  action=""
                  id="contact-form"
                  acceptcharset="UTF-8"
                  className="contact-form"
                >
                  <input
                    type="hidden"
                    name="form_type"
                    defaultvalue="contact"
                  />
                  <input type="hidden" name="utf8" defaultvalue="✓" />
                  <div className="col-lg-12">
                    <input
                      type="text"
                      placeholder="Name"
                      className="form-controlCustomized"
                      // name="contact[name]"
                      // id="ContactFormName"
                      // defaultvalue=""
                      name="name"
                      required
                      value={formData.name}
                      onChange={handleChange}
                    />
                  </div>
                  <div
                    className="col-lg-6"
                    style={{ float: "left", marginTop: 20 }}
                  >
                    <input
                      type="email"
                      placeholder="Email"
                      className="form-controlCustomized"
                      // name="contact[email]"
                      // id="ContactFormEmail"
                      // defaultvalue=""
                      name="email"
                      required
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>
                  <div
                    className="col-lg-6"
                    style={{ float: "left", marginTop: 20 }}
                  >
                    <input
                      type="text"
                      id="ContactFormSubject"
                      // name="contact[subject]"
                      placeholder="Mobile No."
                      //defaultvalue=""
                      className="form-controlCustomized"
                      name="mobileNo"
                      required
                      value={formData.mobileNo}
                      onChange={handleChange}
                      onKeyPress={(event) => {
                        if (
                          !/[0-9]/.test(event.key) ||
                          formData.mobileNo.length >= 10
                        ) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </div>
                  <div
                    className="col-lg-12"
                    style={{ float: "left", marginTop: 20 }}
                  >
                    <input
                      type="text"
                      id="ContactFormSubject"
                      //name="contact[subject]"
                      placeholder="Address"
                      //defaultvalue=""
                      className="form-controlCustomized"
                      name="address"
                      required
                      value={formData.address}
                      onChange={handleChange}
                    />
                  </div>
                  <div
                    className="col-lg-6"
                    style={{ float: "left", marginTop: 20 }}
                  >
                    <input
                      type="text"
                      id="ContactFormSubject"
                      //name="contact[subject]"
                      placeholder="City"
                      //defaultvalue=""
                      className="form-controlCustomized"
                      name="city"
                      required
                      value={formData.city}
                      onChange={handleChange}
                    />
                  </div>
                  <div
                    className="col-lg-6"
                    style={{ float: "left", marginTop: 20 }}
                  >
                    <input
                      type="text"
                      id="ContactFormSubject"
                      //name="contact[subject]"
                      placeholder="State"
                      //defaultvalue=""
                      className="form-controlCustomized"
                      name="state"
                      required
                      value={formData.state}
                      onChange={handleChange}
                    />
                  </div>
                  <div
                    className="col-lg-6"
                    style={{ float: "left", marginTop: 20 }}
                  >
                    <input
                      type="text"
                      id="ContactFormSubject"
                      //name="contact[subject]"
                      placeholder="Country"
                      //defaultvalue=""
                      className="form-controlCustomized"
                      name="country"
                      required
                      // value={formData.country}
                      value="India"
                      onChange={handleChange}
                    />
                  </div>
                  <div
                    className="col-lg-6"
                    style={{ float: "left", marginTop: 20 }}
                  >
                    <input
                      type="text"
                      id="ContactFormSubject"
                      //name="contact[subject]"
                      placeholder="Pin Code"
                      //defaultvalue=""
                      className="form-controlCustomized"
                      name="pincode"
                      required
                      onKeyPress={(event) => {
                        if (
                          !/[0-9]/.test(event.key) ||
                          formData.pincode.length >= 6
                        ) {
                          event.preventDefault();
                        }
                      }}
                      value={formData.pincode}
                      onChange={handleChange}
                    />
                  </div>
                  <div
                    className="col-lg-12"
                    style={{ float: "left", marginTop: 20 }}
                  >
                    <label>
                      <input type="checkbox" required /> &nbsp;&nbsp; I have
                      accepted all{" "}
                      <a
                        href="/TermsandCondition"
                        style={{ color: "#000" }}
                        target="_blank"
                      >
                        terms and conditions
                      </a>
                    </label>
                  </div>

                  <center>
                    <button
                      type="submit"
                      style={{
                        textDecoration: "none",
                        backgroundColor: "#d82028",
                        color: "#fff",
                        padding: "10px 50px 10px 50px",
                        marginTop: 20,
                        borderRadius: 10,
                        border: "none",
                        marginBottom: "20px",
                      }}
                    >
                      PLACE YOUR ORDER NOW
                    </button>
                  </center>
                </form>
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <table className="table table-spriped">
                <tbody>
                  <tr>
                    <th style={{ fontSize: 18, width: "10%" }}>Product</th>
                    <th style={{ fontSize: 18, width: "30%" }}>Details</th>
                    <th style={{ fontSize: 16, width: "20%" }}>Qty</th>
                    <th
                      style={{ fontSize: 16, width: "20%", textAlign: "right" }}
                    >
                      Price
                    </th>
                    <th
                      style={{ fontSize: 16, width: "20%", textAlign: "right" }}
                    >
                      Sub Total
                    </th>
                  </tr>
                  {cartItem &&
                    cartItem.length > 0 &&
                    cartItem?.map((book, index) => (
                      <tr key={index}>
                        <td>
                          <img
                            src={`${REACT_APP_URL}/Image/${book.image}`}
                            alt="Best Sellers"
                            loading="lazy"
                            style={{ height: "12vh" }}
                          />
                        </td>
                        <td style={{ fontWeight: 600, fontSize: 18 }}>
                          {book.name}
                        </td>
                        <td>
                          <input
                            type="number"
                            className="form-control"
                            name="quantity"
                            min={1}
                            max={1000}
                            value={book.quantity || 1}
                            style={{ width: "100%" }}
                            onChange={(e) => {
                              let val = e.target.value;
                              if (val.length > 1 && val.startsWith("0")) {
                                val = val.replace(/^0+/, "");
                              }
                              if (!val || val < 1) {
                                val = 1;
                              }
                              updateOnChangeHandler(val, book);
                            }}
                          />
                        </td>

                        <td style={{ textAlign: "right" }}>Rs. {book.mRP}</td>
                        <td style={{ textAlign: "right" }}>
                          Rs. {book.quantity * book.mRP}
                        </td>
                      </tr>
                    ))}
                  <tr>
                    <th>Subtotal</th>
                    <th></th>
                    <th style={{ textAlign: "right" }}>{totalQnt}</th>
                    <th style={{ textAlign: "right" }}>Rs. {totalPrice}</th>
                    <th style={{ textAlign: "right" }}>Rs. {totalAmmount}</th>
                  </tr>
                </tbody>
              </table>

              {/* Coupon Code Section */}
              <div style={{
                padding: "20px",
                backgroundColor: "#f9f9f9",
                borderRadius: "10px",
                marginTop: "20px"
              }}>
                <h5 style={{ marginBottom: "15px", fontWeight: 600 }}>Have a Coupon Code?</h5>

                {!appliedCoupon ? (
                  <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                    <input
                      type="text"
                      placeholder="Enter coupon code"
                      value={couponCode}
                      onChange={(e) => setCouponCode(e.target.value.toUpperCase())}
                      style={{
                        flex: 1,
                        minWidth: "200px",
                        padding: "10px 15px",
                        border: "1px solid #ddd",
                        borderRadius: "5px",
                        fontSize: "14px",
                      }}
                      disabled={couponLoading}
                    />
                    <button
                      type="button"
                      onClick={validateCoupon}
                      disabled={couponLoading || !couponCode.trim()}
                      style={{
                        padding: "10px 25px",
                        backgroundColor: couponLoading ? "#ccc" : "#28a745",
                        color: "#fff",
                        border: "none",
                        borderRadius: "5px",
                        cursor: couponLoading ? "not-allowed" : "pointer",
                        fontSize: "14px",
                        fontWeight: 500,
                      }}
                    >
                      {couponLoading ? "Validating..." : "Apply Coupon"}
                    </button>
                  </div>
                ) : (
                  <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "10px 15px",
                    backgroundColor: "#d4edda",
                    borderRadius: "5px",
                    border: "1px solid #c3e6cb"
                  }}>
                    <span style={{ color: "#155724", fontWeight: 500 }}>
                      ✓ Coupon "{appliedCoupon.code}" applied!
                    </span>
                    <button
                      type="button"
                      onClick={removeCoupon}
                      style={{
                        padding: "5px 15px",
                        backgroundColor: "#dc3545",
                        color: "#fff",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                        fontSize: "12px",
                      }}
                    >
                      Remove
                    </button>
                  </div>
                )}

                {couponError && (
                  <p style={{ color: "#dc3545", marginTop: "10px", marginBottom: 0, fontSize: "14px" }}>
                    ✗ {couponError}
                  </p>
                )}

                {couponSuccess && !couponError && (
                  <p style={{ color: "#28a745", marginTop: "10px", marginBottom: 0, fontSize: "14px" }}>
                    {couponSuccess}
                  </p>
                )}
              </div>

              {/* Order Summary */}
              <div style={{
                marginTop: "20px",
                padding: "20px",
                backgroundColor: "#fff",
                border: "2px solid #d82028",
                borderRadius: "10px"
              }}>
                <h5 style={{ marginBottom: "15px", fontWeight: 600, color: "#d82028" }}>Order Summary</h5>

                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
                  <span>Subtotal:</span>
                  <span style={{ fontWeight: 500 }}>Rs. {totalAmmount}</span>
                </div>

                {appliedCoupon && (
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px", color: "#28a745" }}>
                    <span>Discount ({appliedCoupon.discountType === "percentage" ? `${appliedCoupon.discountValue}%` : `Rs. ${appliedCoupon.discountValue}`}):</span>
                    <span style={{ fontWeight: 500 }}>- Rs. {discountAmount}</span>
                  </div>
                )}

                <hr style={{ margin: "15px 0" }} />

                <div style={{ display: "flex", justifyContent: "space-between", fontSize: "18px" }}>
                  <span style={{ fontWeight: 600 }}>Total Payable:</span>
                  <span style={{ fontWeight: 700, color: "#d82028" }}>
                    Rs. {appliedCoupon ? finalAmount : totalAmmount}
                  </span>
                </div>

                {appliedCoupon && (
                  <p style={{
                    marginTop: "10px",
                    marginBottom: 0,
                    fontSize: "13px",
                    color: "#28a745",
                    textAlign: "center"
                  }}>
                    🎉 You're saving Rs. {discountAmount} with this coupon!
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="row"
        style={{
          clear: "both",
          height: "10vh",
          background: "linear-gradient(to top, rgb(216, 32, 40, 0.1), #fff)",
        }}
      />
      <div
        className="row"
        style={{
          backgroundColor: "white",
          position: "relative",
          padding: "50px 30px 0px 30px",
          textAlign: "left",
          color: "black",
        }}
      >
        <Footer />
      </div>
    </>
  );
}

export default Checkout;
